import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';
import { ModalOptions } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'custom-clear-cart',
  templateUrl: './custom-clear-cart.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalDialogComponent, TranslateModule],
})
@GenerateLazyComponent()
export class CustomClearCartComponent implements OnInit {
  private checkoutFacade = inject(CheckoutFacade);
  private translate = inject(TranslateService);

  options: ModalOptions;

  ngOnInit(): void {
    this.options = {
      titleText: this.translate.instant('dias.shopping_cart.clear_alldialog.header'),
      rejectText: this.translate.instant('dias.shopping_cart.clear_all.cancel.label'),
      confirmText: this.translate.instant('dias.shopping_cart.clear_all.confirm.label'),
    };
  }

  deleteBasket() {
    this.checkoutFacade.deleteBasket();
  }
}
